module.exports = __webpack_public_path__ + "img/csv.bb0d282e.png";